/*global grecaptcha */
const state = require('./state.js');
const ui = require('../ui');
const vehicle = require('../vehicle');
const DOM = require('./dom.js');
const { useValidation, useKeys } = require('../common.js');

export const init = async () => {
    ui.state.loaderText = 'Te rugăm să aștepți...';
    ui.state.isLoading = true;
    try {
        let response = await fetch(`${process.env.API_URL}/api/content/terms/disclaimer`, {});
        if (!response.ok)
            throw new Error('could not retrieve disclaimer');

        let json = await response.json();
        state.disclaimer.subject = json.subject;
        state.disclaimer.text = json.text;

        response = await fetch(`${process.env.API_URL}/api/content/terms/rca_conditions`, {});
        if (!response.ok)
            throw new Error('could not retrieve rca_conditions');

        json = await response.json();
        state.conditions.subject = json.subject;
        state.conditions.text = json.text;

        ui.state.isLoading = false;

        setTimeout(() => {
            DOM.chkAdult.focus();
        }, 600);
    } catch (err) {
        ui.state.isLoading = false;
        window.location = '/error';
    }
};

//controls
let chkAdult = useValidation(DOM.chkAdult);
let chkDisclaimer = useValidation(DOM.chkDisclaimer);
let chkProductDetails = useValidation(DOM.chkProductDetails);
let chkConditions = useValidation(DOM.chkConditions);
useKeys(DOM.btnTermsNext);

//bindings
state.bind('isVisible', value => {
    DOM.divWrapper.classList[value ? 'add' : 'remove']('view-overlay-terms');
});
state.bind('isExpanded', value => {
    DOM.divWrapper.classList[value ? 'add' : 'remove']('view-overlay-content');
    if (value)
        DOM.divScrollbar.scrollTop = 100000; //IE
});
state.bind('isAdult', DOM.chkAdult);
state.bind('readDisclaimer', DOM.chkDisclaimer);
state.bind('readDisclaimer', value => {
    if (value)
        chkDisclaimer.state.valid = true;
});
state.bind('readProductDetails', DOM.chkProductDetails);
state.bind('readConditions', DOM.chkConditions);
state.bind('readConditions', value => {
    if (value)
        chkConditions.state.valid = true;
});
state.bind('acceptPersonalData', DOM.chkPersonalData);
state.bind('mode', value => {
    if (!value)
        return;
    DOM.lblTermsSubject.innerText = state[value].subject;
    DOM.lblTermsText.innerText = state[value].text;
});

//events
DOM.chkConditions.addEventListener('click', e => {
    if (!state.conditions.read) {
        e.preventDefault();
        state.mode = 'conditions';
        state.isVisible = true;
        state.isExpanded = false;
    }
});
DOM.btnTermsExpand.addEventListener('click', () => {
    state.isExpanded = true;
    if (state.mode === 'conditions')
        state.conditions.read = true;
});
DOM.lnkDisclaimer.addEventListener('click', e => {
    e.preventDefault();
    state.mode = 'disclaimer';
    state.isVisible = true;
    state.isExpanded = false;
});
DOM.lnkProductDetails.addEventListener('click', e => {
    e.preventDefault();

    window.open(`https://www.allianztiriac.ro/content/dam/onemarketing/cee/azro/documente/ipid/IPID_RCA_PJ.pdf`, '_blank');
});
DOM.lnkConditions.addEventListener('click', e => {
    e.preventDefault();
    state.mode = 'conditions';
    state.isVisible = true;
    state.isExpanded = false;
});
DOM.btnTermsReject.addEventListener('click', e => {
    e.preventDefault();
    switch (state.mode) {
        case 'disclaimer':
            state.readDisclaimer = false;
            break;
        case 'conditions':
            state.readConditions = false;
            break;
    }
    state.isVisible = false;
});
DOM.btnTermsAccept.addEventListener('click', e => {
    e.preventDefault();
    switch (state.mode) {
        case 'disclaimer':
            state.readDisclaimer = true;
            break;
        case 'conditions':
            if (!state.conditions.read) {
                ui.notyf.error('Te rugăm să parcurgi până la final Condițiile de asigurare');
                return;
            }
            state.readConditions = true;
            state.conditions.read = true;
            break;
    }
    state.isVisible = false;
});
DOM.btnTermsNext.addEventListener('click', e => {
    e.preventDefault();

    chkAdult.state.valid = true;
    chkDisclaimer.state.valid = true;
    chkProductDetails.state.valid = true;
    chkConditions.state.valid = true;

    let isValid = true;
    if (!state.isAdult) {
        chkAdult.state.valid = false;
        isValid = false;
    }
    if (!state.readDisclaimer) {
        chkDisclaimer.state.valid = false;
        isValid = false;
    }
    if (!state.readProductDetails) {
        chkProductDetails.state.valid = false;
        isValid = false;
    }
    if (!state.readConditions) {
        chkConditions.state.valid = false;
        isValid = false;
    }

    if (!isValid)
        return;

    grecaptcha.execute();
});
//async callback from captcha
window.submitTerms = async (recaptchaCode) => {
    if (ui.state.isLoading)
        return;

    ui.state.loaderText = 'Te rugăm să aștepți...';
    ui.state.isLoading = true;

    await new Promise(resolve => setTimeout(resolve, 1000));

    let response = await fetch(`${process.env.API_URL}/api/rcapolicy/webrequest`, {
        method: 'POST',
        body: JSON.stringify({
            captcha: recaptchaCode
        }),
        headers: {
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) {
        ui.state.isLoading = false;
        throw new Error('captcha invalid');
    }
    let json = await response.json();

    ui.state.flowId = json.id;
    ui.state.slide = [1, 0];
    vehicle.init();

    ui.state.isLoading = false;
};

module.exports.state = state;
module.exports.DOM = DOM;